import {TConditionStep, TUIConditionPayload} from 'src/containers/Triggers/types';

type TConditionNodeData = {
  step: TConditionStep<TUIConditionPayload>;
  ui: {
    selectedConditionId?: string;
  };
};

const makeConditionNodeData = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  step: TConditionStep<TUIConditionPayload> & any,
): TConditionNodeData => ({
  step,
  ui: {
    selectedConditionId: undefined,
  },
});

export {TConditionNodeData, makeConditionNodeData};
